import { Outlet } from 'react-router'
import { getI18n } from 'src/i18n/i18n.middleware'
import { SITE_NAME, staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/landing'

export const handle = {
  name: 'landing',
  track: { scene: 'landing', section: 'landing' },
}

export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: `${t('server:meta.landing.title', { defaultValue: 'AIでアニメアートを創ろう' })} | ${SITE_NAME}`,
    description: t('server:meta.landing.description', {
      defaultValue:
        '10万以上のアニメモデル × 毎日無料クレジット。プロンプトひとつで、神絵が生まれる。今すぐ無料体験。',
    }),
    image:
      'https://cdn.pixai.art/artifacts/app-414283d7081a3362eb2d6a0805c3152900b1fb8e/assets/mio-header-CaE_7ao1.webp',
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export default function LandingLayoutRoute() {
  return (
    <div
      className="min-h-screen overflow-x-hidden bg-white font-sans text-gray-900"
      style={{ fontFamily: "'Noto Sans JP', 'Inter', system-ui, sans-serif" }}
    >
      {/*
        The landing nav is owned by `<Navbar>` inside `LandingHome` —
        it has the full Experience/Features/Pricing/FAQ/Try-now link
        set, smooth-scroll behavior, the scroll progress bar, and the
        mobile dropdown. The route layout previously rendered a
        bare `<header>` here that only had "PixAI" + "Try now" pinned
        with the same `fixed top-5` z-index, so the two stacked on top
        of each other and the proper navbar appeared "missing" in
        screenshots. The simpler layout-level header has been
        removed; only the footer below remains in this layout.
       */}
      <Outlet />
      <footer className="border-t border-gray-200 py-10 text-center">
        <div className="mx-auto max-w-[1200px] px-6">
          <div className="mb-3 flex justify-center gap-6">
            <a
              href="https://pixai.art/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 transition-colors hover:text-gray-600"
            >
              Terms
            </a>
            <a
              href="https://pixai.art/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 transition-colors hover:text-gray-600"
            >
              Privacy
            </a>
            <a
              href="https://pixai.art"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 transition-colors hover:text-gray-600"
            >
              PixAI.art
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}
